export const isValidLocale = (locale: string): boolean => {
    try {
        return typeof Intl.DateTimeFormat(locale) !== 'undefined';
    } catch {
        return false;
    }
};
